import { Stream, SourceStream, StreamStatusCode, StreamType } from '@/types/streams'
import { SystemStatus } from '@/types/ops'
import { UserNetworkStats } from '@/types/networkstats'

export const getStreamStatus = (stream: Stream | SourceStream,
                                stats: UserNetworkStats | undefined =  undefined,
                                presence = false, delta = 0): StreamStatusCode => {
  // console.log('getStreamStatus', stream, stats, presence, delta)
  switch (stream.type) {
    case StreamType.Broadcast:
      return calcBroadcastStatus(stream, delta)
    case StreamType.Caster:
      return calcCasterStatus(stream, stats, presence, delta)
    case StreamType.Stream:
      return calcStreamStatus(stream, delta)
    case StreamType.Output:
      return calcStreamStatus(stream, delta)
    default:
      break;
  }
  return StreamStatusCode.None
}

const calcBroadcastStatus = (stream: Stream | SourceStream, delta: number): StreamStatusCode => {
  // console.log('calcBroadcastStatus', stream, delta)
  let status = StreamStatusCode.None
  if (stream.ngcvp_status === SystemStatus.OK) {
    status = StreamStatusCode.StreamGood
  } else if (stream.srt_state !== undefined && stream.srt_state != 'green') {
    status = StreamStatusCode.SRTError
  } else if (stream.ngcvp_status === SystemStatus.ERROR) {
    // stream boot up grace period
    if (delta < 60) {
      status = StreamStatusCode.StreamBooting
    } else {
      status = StreamStatusCode.StreamError
    }
  } else if (stream.ngcvp_status === SystemStatus.NONE) {
    if (delta < 60) {
      status = StreamStatusCode.StreamBooting
    }
  }
  return status
}

const calcCasterStatus = (stream: Stream | SourceStream,
                          stats: UserNetworkStats | undefined,
                          presence: boolean = false, delta: number): StreamStatusCode => {
  // console.log('calcCasterStatus', Object.keys(stream).length, stats, presence, delta)
  let status = StreamStatusCode.CasterNotPresent
  if (stream.ngcvp_status !== undefined) {
    if (stream.ngcvp_status === SystemStatus.ERROR) {
      // stream boot up grace period
      if (delta < 60) {
        status = StreamStatusCode.CasterConnecting
      } else {
        status = StreamStatusCode.CasterError
      }
    } else if (stream.ngcvp_status === SystemStatus.NONE) {
      if (presence) {
        status = StreamStatusCode.CasterPresent
      } else {
        status = StreamStatusCode.CasterNotPresent
      }
    } else if (stream.ngcvp_status === SystemStatus.OK) {
      const uploadscore = stats?.upload?.score || 0
      const downloadscore = stats?.download?.score || 0
      if (testPoorNetwork(true, uploadscore, downloadscore)) {
        status = StreamStatusCode.CasterCastingIssues
      } else {
        status = StreamStatusCode.CasterCasting
      }
    }
  } else {
    if (presence) {
      status = StreamStatusCode.CasterPresent
    } else {
      status = StreamStatusCode.CasterNotPresent
    }
  }
  // console.log('calcCasterStatus', status, presence)
  return status
}

const calcStreamStatus = (stream: Stream | SourceStream, delta: number): StreamStatusCode => {
  // console.log('calcOutputStatus', stream)
  let status = StreamStatusCode.None
  if (stream.ngcvp_status === SystemStatus.OK) {
    status = StreamStatusCode.OutputGood
  } else if (stream.ngcvp_status === SystemStatus.NETWORK_SLOW) {
    status = StreamStatusCode.OutputLowBandwidth
  } else if (stream.ngcvp_status === SystemStatus.ERROR) {
    if ((stream.active === undefined || stream.active) && delta < 60) {
      status = StreamStatusCode.StreamBooting
    } else {
      status = StreamStatusCode.StreamError
    }
  }
  // console.log('calcOutputStatus', status)
  return status
}


export const testPoorNetwork = (isCasting: boolean, uploadScore: number, downloadScore: number): boolean => {
  // console.log('testPoorNetwork', isCasting, uploadScore, downloadScore)
  let status = false
  if (isCasting) {
    if (uploadScore <= 2) {
      status = true
    }
  }
  if (downloadScore <= 2) {
    status = true
  }
  return status
}

export const srtInputLine = (stream: Stream) : string => {
  let result = ''
  if (stream.srt_info !== undefined) {
    const srt_info = stream.srt_info
    let ip = srt_info?.ip
    if (ip === undefined){
      ip = srt_info.nimbleserver
    }
    const port = srt_info.port
    let modeStr = ''
    if (srt_info?.mode !== undefined) {
      modeStr = '?mode=' + srt_info.mode
    }
    result = `srt://${ip}:${port}${modeStr}`
  }
  return result
}
export const srtOutputLine = (stream: Stream) : string => {
  let result = ''
  if (stream.srt_info !== undefined){
    const srt_info = stream.srt_info
    const nimbleserver = srt_info.nimbleserver
    const port = srt_info.port
    result = `srt://${nimbleserver}:${port}`
  }
  return result
}
export const srtState = (stream: Stream) : string => {
      return 'state = ' + (stream.srt_state ? stream.srt_state : 'orange')
}
